import { DatatableRow } from '@monksflow/monks-ui';
import type { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

export interface TableRowProps extends ComponentPropsWithoutRef<'tr'> {
  /** Tints the whole row on pointer-over. Does not imply the row is clickable. */
  hover?: boolean;
}

/**
 * Row shape shared by the header and the body: cell borders are stripped and the
 * outer two cells are rounded, so a row reads as one pill rather than a grid.
 * The radii sit on the cells because `<tr>` itself cannot be rounded.
 */
export function TableRow({ hover, className, ...props }: TableRowProps) {
  return (
    <DatatableRow
      {...props}
      className={twMerge(
        '[&>*]:border-0 [&>*:first-of-type]:rounded-l-lg [&>*:last-child]:rounded-r-lg',
        hover && 'hover:[&>*]:bg-muted',
        className,
      )}
    />
  );
}
